import {inject, bindable, bindingMode, customElement} from 'aurelia-framework';
import {ContentService} from '../../../../services/content-service';
import {map} from 'lodash';

@inject(ContentService)
@customElement('group-invite')
export class GroupInvite {
  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) groupList;
  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) contactId;
  @bindable({
    defaultBindingMode: bindingMode.twoWay
  })visible;

  selectedGroups: number[];
  message: boolean;

  constructor(private __contentService: ContentService) {
    this.selectedGroups = [];
    let userInfo = this.__contentService.getUserInfo();
    this.message = false;
  }

  sendInvite() {
    this.__contentService.sendGroupsInvitation(this.contactId, this.selectedGroups).then(()=>{
      this.message = true;
      setTimeout(()=>{
        this.message = false;
        this.close();
      }, 3000);
    });
  }
  checkAll() {
    this.selectedGroups = map(this.groupList, g => g.id);
  }

  uncheckAll() {
    this.selectedGroups = [];
  }
  close() {
    this.visible = false;
    this.selectedGroups = [];
    this.groupList = [];
  }
}

